import React from 'react'
import { useSelector } from 'react-redux'
import styles from './Footer.module.css'
import { Link } from 'react-router-dom'
import appStoreBtn from '../../assets/btn-app-store.svg'
import ggPlayBtn from '../../assets/btn-gg-play.svg'
import icFb from '../../assets/ic-facebook.svg'
import icInsta from '../../assets/ic-insta.svg'
import icTwitter from '../../assets/ic-twitter.svg'
import { appURL, social } from '../../constants'
import logo from '../../assets/sushiroll_logo.svg'
import { detectAgent } from '../../utils'

const Footer = () => {
  const isMobile = detectAgent('mobile')

  const token = useSelector((state) => state.auth.token)

  const menuSection = (
    <>
      {token && (
        <div className={styles.grow1}>
          <Link to='/subscription'>Subscribe</Link>
        </div>
      )}
      <div className={styles.grow1}>
        <Link to='/about-us'>About Us</Link>
      </div>
      <div className={styles.grow1}>
        <Link to='/terms'>Terms and Conditions</Link>
      </div>
      <div className={styles.grow1}>
        <Link to='/privacy-policy'>Privacy Policy</Link>
      </div>
      <div className={styles.grow1}>
        <Link to='/faqs'>FAQs</Link>
      </div>
    </>
  )
  return (
    <div className={styles['footer-wrapper']}>
      <div className={styles.footerContent}>
        <div className={styles['footer']}>
          <section className={styles.layout}>
            <div className={!isMobile && styles.grow1}>
              <Link to='/'>
                <img src={logo} alt='logo' className={styles.logo} />
              </Link>
            </div>
            {!isMobile && (
              <div className={styles.grow1}>
                <section className={styles.layout}>{menuSection}</section>
              </div>
            )}
            <div className={!isMobile && styles.grow1}>
              <div className={styles.iconsWrapper}>
                <a
                  rel='noopener noreferrer'
                  target='_blank'
                  href={social.SUSHIROLL_INSTAGRAM}
                >
                  <img src={icInsta} alt='icon-instagram' />
                </a>
                <a
                  rel='noopener noreferrer'
                  target='_blank'
                  href={social.SUSHIROLL_FACEBOOK}
                >
                  <img src={icFb} alt='icon-facebook' />
                </a>
                <a
                  rel='noopener noreferrer'
                  target='_blank'
                  href={social.SUSHIROLL_TWITTER}
                >
                  <img src={icTwitter} alt='icon-twitter' />
                </a>
              </div>
            </div>
          </section>
          {isMobile && (
            <section className={styles.layout}>
              <div className={styles.grow1}>
                <div className={styles.menu}>{menuSection}</div>
              </div>
            </section>
          )}
          <section className={styles.layout} style={{ marginTop: '30px' }}>
            <div className={styles.grow1}>
              <div className={styles['head']}>Download Our App</div>
              <Link to={appURL.APP_STORE} target='_blank'>
                <img alt='app-store-button' src={appStoreBtn} />
              </Link>
              <Link to={appURL.GOOGLE_PLAY} target='_blank'>
                <img alt='google-play-button' src={ggPlayBtn} />
              </Link>
            </div>
          </section>
          <section className={styles.copyrightEmail}>
            Copyright © {new Date().getFullYear()} Sushiroll All Rights Reserved{' '}
            {isMobile ? <br /> : ' | '}
            <a href={`mailto:${social.SUSHIROLL_EMAIL}`} target='_top'>
              {social.SUSHIROLL_EMAIL}
            </a>
          </section>
          <section className={styles.appVersion}>
            Application Version 1.0.0
          </section>
        </div>
      </div>
    </div>
  )
}

export default Footer
